import React, { Component } from 'react';
import { Button, Row, Col, Modal, Form } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import SignalRService from '../../controllers/SignalRService';
import Toastr from '../utils/toastr';

class RecoverPassword extends Component {

    constructor(props) {
        
        super(props)

        this.state = {
            username: "",
            loading: false
        }

        this.setUsername = this.setUsername.bind(this);
        this.keyDown = this.keyDown.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.recoverPasswordEvent = this.recoverPasswordEvent.bind(this);
        SignalRService.registerRecoverPassword(this.recoverPasswordEvent);
       
        this.toastrRef = React.createRef();
    }

    setUsername(e) {
        e.preventDefault();
        this.setState({
            username: e.target.value
        });
    }

    keyDown = (e) => {
        if (e.keyCode === 13) {
            this.sendEmail(e);
        }
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    sendEmail = e => {
        this.setLoading(true);
        SignalRService.recoverPassword({
            tenantName: window.location.host.split(".")[0], // How it should be
            userName: this.state.username,
            referrer: window.location.href
        })
    }

    recoverPasswordEvent(res) {
        this.setLoading(false);

        if (res) {
            this.toastrRef.current.setType("success");
            this.toastrRef.current.setMessage(this.props.t("recoveremailsent"));
            this.toastrRef.current.show();
        } else{
            this.toastrRef.current.setType("error");
            this.toastrRef.current.setMessage(this.props.t("recoveremailsenterror"));
            this.toastrRef.current.show();
        }
        this.props.toggleModal();
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} size="lg" backdrop="static">
                    <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                        <Modal.Header closeButton>
                            <Modal.Title><FontAwesomeIcon icon={duotone("key")} /> {this.props.t("recoverpwd")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    <Form>
                                        <Form.Group className="mb-4" controlId="fcemail">
                                            <Form.Label>{this.props.t("username")}</Form.Label>
                                            <Form.Control type="text" value={this.state.username} onChange={this.setUsername} onKeyDown={this.keyDown} autoFocus />
                                            <Form.Text className="text-muted">
                                            </Form.Text>
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={this.sendEmail}>
                                <FontAwesomeIcon icon={duotone("paper-plane-top")} />  {this.props.t("send")}
                            </Button>
                        </Modal.Footer>
                    </BlockUi>
                </Modal>
                <Toastr ref={this.toastrRef} />
            </>)
    }
}



export default withTranslation()(RecoverPassword);